import { render } from "./Iris.vue?vue&type=template&id=c2b2510e&scoped=true&ts=true"
import script from "./Iris.vue?vue&type=script&lang=ts"
export * from "./Iris.vue?vue&type=script&lang=ts"

import "./Iris.vue?vue&type=style&index=0&id=c2b2510e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b2510e"]])

export default __exports__